import React from "react";
import { MdEmail, MdPhone } from "react-icons/md";
import { FaFacebookF, FaWhatsapp, FaInstagram, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6"; // X (Twitter logo) is in fa6

const Address = () => {
    return (
        <div className="border-bottom py-3 shadow-none">
            <div className="container px-5 d-flex justify-content-between align-items-center">

                {/* Left Side - Email & Phone */}
                <div className="d-flex align-items-center gap-4">
                    <span className="d-flex align-items-center text-muted gap-2 fa-14">
                        <MdEmail size={15} /> ircs_jal@yahoo.in, ircs1953@gmail.com
                    </span>
                    <span className="d-flex align-items-center text-muted gap-2 fa-14">
                        <MdPhone size={15} /> 0257-2226233, 2236255, 2235855
                    </span>
                </div>

                {/* Center - Social Icons */}
                <div className="d-flex align-items-center gap-4">
                    <a href="https://www.facebook.com/redcrossjalgaon" target="_blank" className="text-muted"><FaFacebookF size={16} /></a>
                    <a href="https://api.whatsapp.com/send/?phone=9422436566&text&type=phone_number&app_absent=0" target="_blank" className="text-muted"><FaWhatsapp size={16} /></a>
                    <a href="#" target="_blank" className="text-muted"><FaXTwitter size={16} /></a>
                    <a href="https://www.instagram.com/ircs_jalgaon/?igsh=MWVicG53dzhjZ3J3ZQ%3D%3D#" target="_blank" className="text-muted"><FaInstagram size={16} /></a>
                    <a href="https://www.youtube.com/@indianredcrosssocietyjalga8046" target="_blank" className="text-muted"><FaYoutube size={16} /></a>
                </div>

            </div>
        </div>
    );
};

export default Address;
